import { render, staticRenderFns } from "./MortgageQuestionnaire.vue?vue&type=template&id=bd0cd496&"
import script from "./MortgageQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./MortgageQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports